import { ReactNode, memo } from 'react'
import { useMaskedAssets } from './hooks'

export const MaskedAssets = memo<{ children: ReactNode; masked?: ReactNode }>(
  ({ children, masked }) => {
    const [maskedAssets] = useMaskedAssets()
    if (maskedAssets) {
      if (masked) {
        return <>{masked}</>
      } else {
        return <>******</>
      }
    }
    return <>{children}</>
  },
)
